import { Button } from '@viastud/ui/button'
import { Input } from '@viastud/ui/input'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@viastud/ui/select'
import { GradeEnum, SubjectEnum } from '@viastud/utils'
import { LayoutGrid, List, Search } from 'lucide-react'
import type * as React from 'react'

interface BookingFiltersProps {
  searchValue: string
  onSearchChange: (value: string) => void
  selectedGrade: string
  selectedSubject: string
  onSubjectChange: (value: string) => void
  viewMode: 'grid' | 'list'
  onViewModeChange: (mode: 'grid' | 'list') => void
}

export const BookingFilters: React.FC<BookingFiltersProps> = ({
  searchValue,
  onSearchChange,
  selectedGrade,
  selectedSubject,
  onSubjectChange,
  viewMode,
  onViewModeChange,
}) => {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-center">
      <div className="relative flex-1">
        <Input
          placeholder="Rechercher un chapitre ou un cours..."
          value={searchValue}
          onChange={(e) => {
            onSearchChange(e.target.value)
          }}
          className="w-full pl-10"
          buttonContent={<Search className="size-4 text-neutral-400" />}
        />
      </div>

      <div className="flex w-full items-center gap-3 md:w-auto">
        <Select value={selectedGrade} disabled>
          <SelectTrigger className="w-40">
            <SelectValue placeholder="Niveau" />
          </SelectTrigger>
          <SelectContent>
            {Object.entries(GradeEnum).map(([value, label]) => (
              <SelectItem key={value} value={value}>
                {label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Select value={selectedSubject} onValueChange={onSubjectChange}>
          <SelectTrigger className="w-40">
            <SelectValue placeholder="Matière" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="ALL">Toutes les matières</SelectItem>
            {Object.entries(SubjectEnum).map(([value, label]) => (
              <SelectItem key={value} value={value}>
                {label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <div className="flex items-center rounded-full border border-neutral-200 bg-white p-1">
          <Button
            variant="none"
            size="icon"
            className={cn(
              'size-8 rounded-full transition-colors',
              viewMode === 'grid' ? 'bg-blue-50 text-blue-600' : 'text-neutral-400'
            )}
            onClick={() => {
              onViewModeChange('grid')
            }}
          >
            <LayoutGrid className="size-4" />
          </Button>
          <Button
            variant="none"
            size="icon"
            className={cn(
              'size-8 rounded-full transition-colors',
              viewMode === 'list' ? 'bg-blue-50 text-blue-600' : 'text-neutral-400'
            )}
            onClick={() => {
              onViewModeChange('list')
            }}
          >
            <List className="size-4" />
          </Button>
        </div>
      </div>
    </div>
  )
}

// Helper to use cn in this file if needed, or import it
import { cn } from '@viastud/ui/lib/utils'
